import React, { useState } from 'react';
import { Star, CheckCircle2, MapPin, Phone, MessageCircle } from 'lucide-react';

const allTestimonials = [
  { name: 'Sophie M.', city: 'Genève', date: 'Il y a 2 jours', rating: 5, service: 'Retour Affectif', text: "Maître Diamma a fait revenir mon mari en seulement 5 jours ! Je ne pensais pas que c'était possible. Notre couple est maintenant plus fort que jamais. Merci infiniment Maître Diamma !" },
  { name: 'Fatima K.', city: 'Carouge', date: 'Il y a 3 jours', rating: 5, service: 'Voyance', text: "Une consultation de voyance exceptionnelle. Tout ce que Maître Diamma m'a dit s'est réalisé. Il a vu des choses sur ma vie que personne ne pouvait savoir." },
  { name: 'Pierre D.', city: 'Lausanne', date: 'Il y a 4 jours', rating: 5, service: 'Désenvoûtement', text: "J'étais victime d'un envoûtement depuis des années. Maître Diamma a identifié la source et m'en a libéré. Ma vie a complètement changé." },
  { name: 'Amina B.', city: 'Genève', date: 'Il y a 5 jours', rating: 5, service: 'Retour Affectif', text: "Mon ex est revenu me supplier de le reprendre après seulement 4 jours ! Je recommande Maître Diamma à toutes les personnes qui souffrent en amour." },
  { name: 'Thomas L.', city: 'Vernier', date: 'Il y a 1 semaine', rating: 5, service: 'Chance', text: "Grâce aux rituels de Maître Diamma, j'ai gagné plusieurs fois aux jeux. Ma situation financière s'est considérablement améliorée." },
  { name: 'Marie-Claire R.', city: 'Meyrin', date: 'Il y a 1 semaine', rating: 5, service: 'Protection', text: "Maître Diamma m'a protégée contre les mauvais sorts de ma belle-famille. Depuis, tout va mieux dans mon foyer." },
  { name: 'Hassan O.', city: 'Lancy', date: 'Il y a 1 semaine', rating: 5, service: 'Réussite', text: "J'ai obtenu mon permis de conduire grâce aux rituels de Maître Diamma après 3 échecs. Je n'y croyais plus !" },
  { name: 'Nathalie V.', city: 'Genève', date: 'Il y a 2 semaines', rating: 5, service: 'Retour Affectif', text: "Mon compagnon m'avait quittée pour une autre femme. Maître Diamma a travaillé et il est revenu en 6 jours. Incroyable." },
  { name: 'Jean-Marc F.', city: 'Nyon', date: 'Il y a 2 semaines', rating: 5, service: 'Voyance', text: "La précision de Maître Diamma est remarquable. Il m'a prédit des événements qui se sont réalisés au jour près." },
  { name: 'Aïcha D.', city: 'Onex', date: 'Il y a 2 semaines', rating: 5, service: 'Famille', text: "Grâce à Maître Diamma, les conflits dans ma famille ont cessé. Nous vivons enfin en paix." },
  { name: 'Laurent B.', city: 'Genève', date: 'Il y a 3 semaines', rating: 5, service: 'Travail', text: "J'ai retrouvé un emploi excellent en 2 semaines grâce aux rituels de Maître Diamma. Il a débloqué ma situation." },
  { name: 'Isabelle P.', city: 'Thonex', date: 'Il y a 3 semaines', rating: 5, service: 'Retour Affectif', text: "Après 3 mois de séparation, mon mari est revenu en seulement 5 jours grâce à Maître Diamma." },
  { name: 'Mohamed A.', city: 'Versoix', date: 'Il y a 3 semaines', rating: 5, service: 'Désenvoûtement', text: "Maître Diamma m'a libéré d'un mauvais sort qui durait depuis des années. Je revis enfin normalement." },
  { name: 'Caroline G.', city: 'Montreux', date: 'Il y a 1 mois', rating: 5, service: 'Chance', text: "Depuis les rituels de chance, ma vie a changé. J'ai eu des opportunités incroyables." },
  { name: 'David S.', city: 'Vevey', date: 'Il y a 1 mois', rating: 5, service: 'Retour Affectif', text: "Ma femme est revenue après un an de séparation ! Maître Diamma est vraiment exceptionnel." },
  { name: 'Sylvie T.', city: 'Genève', date: 'Il y a 1 mois', rating: 5, service: 'Protection', text: "J'ai senti la différence dès le premier jour. La protection de Maître Diamma est puissante." },
  { name: 'Philippe M.', city: 'Morges', date: 'Il y a 1 mois', rating: 5, service: 'Voyance', text: "La voyance de Maître Diamma est d'une précision incroyable. Tout ce qu'il dit se réalise." },
  { name: 'Aminata S.', city: 'Carouge', date: 'Il y a 1 mois', rating: 5, service: 'Retour Affectif', text: "Mon ex est revenu en 3 jours ! Le travail de Maître Diamma est rapide et efficace." },
  { name: 'François R.', city: 'Genève', date: 'Il y a 1 mois', rating: 5, service: 'Réussite', text: "J'ai réussi mes examens grâce aux rituels de Maître Diamma. Il a changé ma vie." },
  { name: 'Mariam C.', city: 'Lancy', date: 'Il y a 2 mois', rating: 5, service: 'Famille', text: "Les problèmes familiaux qui empoisonnaient ma vie depuis des années ont été résolus." },
  { name: 'Roberto K.', city: 'Genève', date: 'Il y a 2 mois', rating: 5, service: 'Retour Affectif', text: "Ma femme voulait divorcer. Grâce à Maître Diamma, nous sommes réconciliés. Merci mille fois." },
  { name: 'Sandrine W.', city: 'Fribourg', date: 'Il y a 2 mois', rating: 5, service: 'Voyance', text: "Consultation exceptionnelle. Maître Diamma m'a tout dit sur ma vie sans que je parle." },
  { name: 'Youssef H.', city: 'Lausanne', date: 'Il y a 2 mois', rating: 5, service: 'Désenvoûtement', text: "Après le désenvoûtement, j'ai retrouvé ma santé et mon énergie. Un vrai miracle." },
  { name: 'Claire N.', city: 'Genève', date: 'Il y a 2 mois', rating: 5, service: 'Protection', text: "La protection spirituelle de Maître Diamma m'a sauvée. Je vis enfin sereinement." },
  { name: 'Bernard J.', city: 'Berne', date: 'Il y a 2 mois', rating: 5, service: 'Chance', text: "Les rituels de chance ont changé ma vie financière. Merci Maître Diamma." },
  { name: 'Ousmane D.', city: 'Genève', date: 'Il y a 3 mois', rating: 5, service: 'Retour Affectif', text: "Mon ex-femme est revenue au bout de 5 jours. Maître Diamma est un homme de parole." },
  { name: 'Valérie F.', city: 'Neuchâtel', date: 'Il y a 3 mois', rating: 5, service: 'Voyance', text: "La voyance de Maître Diamma est la meilleure que j'ai expérimentée. Précis et bienveillant." },
  { name: 'Patrick E.', city: 'Genève', date: 'Il y a 3 mois', rating: 5, service: 'Travail', text: "J'ai été promu au travail après les rituels de réussite. Incroyable efficacité !" },
  { name: 'Kadiatou B.', city: 'Vernier', date: 'Il y a 3 mois', rating: 5, service: 'Retour Affectif', text: "Mon copain est revenu en 4 jours après m'avoir quittée. Maître Diamma est formidable." },
  { name: 'Christine L.', city: 'Genève', date: 'Il y a 3 mois', rating: 5, service: 'Famille', text: "Ma belle-mère a cessé de s'opposer à notre mariage grâce à Maître Diamma." },
];

const serviceFilters = ['Tous', 'Retour Affectif', 'Voyance', 'Désenvoûtement', 'Protection', 'Chance', 'Réussite', 'Famille', 'Travail'];

export const Testimonials = () => {
  const [filter, setFilter] = useState('Tous');
  const [visibleCount, setVisibleCount] = useState(6);

  const filtered = filter === 'Tous' ? allTestimonials : allTestimonials.filter(t => t.service === filter);
  const visible = filtered.slice(0, visibleCount);

  return (
    <section id="temoignages" className="py-14 bg-neutral-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <span className="text-amber-500 text-sm font-semibold tracking-widest uppercase">Avis Vérifiés Clients</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-4 mb-6" style={{fontFamily: 'Cormorant Garamond, serif'}}>
            <span className="text-amber-400">800+ Clients</span> Font Confiance à Maître Diamma
          </h2>
          <p className="text-amber-100/60 max-w-2xl mx-auto">
            Découvrez les témoignages de clients satisfaits à Genève et en Suisse.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8 max-w-3xl mx-auto">
          {[
            { value: '800+', label: 'Clients satisfaits' },
            { value: '4.9/5', label: 'Note moyenne' },
            { value: '98%', label: 'Avis positifs' },
            { value: '150', label: 'Avis vérifiés' },
          ].map(stat => (
            <div key={stat.label} className="text-center p-4 rounded-xl bg-amber-500/5 border border-amber-500/10">
              <div className="text-2xl font-bold text-amber-400" style={{fontFamily: 'Cormorant Garamond, serif'}}>{stat.value}</div>
              <div className="text-xs text-amber-200/60">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {serviceFilters.map(s => (
            <button
              key={s}
              onClick={() => { setFilter(s); setVisibleCount(6); }}
              className={`text-xs sm:text-sm px-4 py-1.5 rounded-full border transition-all ${
                filter === s
                  ? 'bg-amber-500/20 border-amber-500/50 text-amber-300'
                  : 'bg-amber-500/5 border-amber-500/10 text-amber-200/60 hover:bg-amber-500/10 hover:border-amber-500/30'
              }`}
              data-testid={`filter-${s.toLowerCase().replace(/\s/g, '-')}`}
            >
              {s}
            </button>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {visible.map((t, i) => (
            <div key={i} className="bg-gradient-to-b from-neutral-900 to-neutral-950 border border-amber-500/20 rounded-xl p-5 hover:border-amber-500/40 transition-all" data-testid={`testimonial-${i}`}>
              {/* Header */}
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-500/30 to-amber-600/10 flex items-center justify-center">
                    <span className="text-amber-400 font-bold text-sm">{t.name[0]}</span>
                  </div>
                  <div>
                    <h4 className="text-white font-medium text-sm">{t.name}</h4>
                    <div className="flex items-center space-x-1">
                      <MapPin className="w-3 h-3 text-amber-500" />
                      <span className="text-amber-200/50 text-xs">{t.city}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-1">
                  <CheckCircle2 className="w-3 h-3 text-green-500" />
                  <span className="text-green-400/70 text-xs">Vérifié</span>
                </div>
              </div>

              {/* Stars + Date */}
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-1">
                  {[...Array(t.rating)].map((_, j) => (
                    <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" />
                  ))}
                </div>
                <span className="text-amber-200/40 text-xs">{t.date}</span>
              </div>

              {/* Service Badge */}
              <span className="inline-block text-xs text-amber-400/80 bg-amber-500/10 border border-amber-500/20 rounded-full px-3 py-0.5 mb-3">
                {t.service}
              </span>

              {/* Text */}
              <p className="text-amber-100/60 text-sm leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>

        {/* Load More */}
        {visibleCount < filtered.length && (
          <div className="text-center mt-8">
            <button
              onClick={() => setVisibleCount(prev => prev + 6)}
              className="text-amber-400 hover:text-amber-300 font-medium border border-amber-500/30 px-6 py-2.5 rounded-lg hover:bg-amber-500/10 transition-all"
              data-testid="load-more-btn"
            >
              Voir plus de témoignages
            </button>
          </div>
        )}

        {/* Bottom CTA */}
        <div className="text-center mt-12 bg-neutral-900/50 border border-amber-500/30 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Cormorant Garamond, serif'}}>
            Contactez <span className="text-amber-400">Maître Diamma</span> - Marabout Africain Genève
          </h3>
          <p className="text-amber-100/70 mb-6 max-w-2xl mx-auto">
            Consultation gratuite avec le meilleur marabout de Genève. Résultats garantis en 3 à 7 jours.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:+41767836186" className="flex items-center space-x-2 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-bold px-8 py-4 rounded-xl hover:from-amber-400 hover:to-amber-500 transition-all" data-testid="testimonials-call-btn">
              <Phone className="w-5 h-5" /><span>+41 76 783 61 86</span>
            </a>
            <a href="https://wa.me/41767836186" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 bg-green-600 hover:bg-green-500 text-white font-bold px-8 py-4 rounded-xl transition-all" data-testid="testimonials-whatsapp-btn">
              <MessageCircle className="w-5 h-5" /><span>WhatsApp</span>
            </a>
          </div>
          <p className="text-amber-200/50 text-sm mt-4">Disponible 7j/7 de 8h à 23h30 - Genève et toute la Suisse</p>
        </div>
      </div>
    </section>
  );
};
